import { ModalProps } from 'antd';
import styled from 'styled-components';

import { ModalBase } from './common';
import { useDisplayContext } from '~src/context/DisplayContext';

const Modal = styled(ModalBase)<{ background?: string; isMobile?: boolean }>(
  ({ background = 'inherit', isMobile }) => ({
    '.ant-modal-header': {
      background,
      borderRadius: isMobile ? '8px 8px 0 0' : '32px 32px 0 0',
      borderBottom: 'none',
    },
    '.ant-modal-body': {
      background,
      padding: isMobile ? '12px' : '64px',
    },
    '.ant-modal-title': { textAlign: 'center' },
  })
);

type ModalBaseProps = ModalProps & {
  setVisible?: (visible: false) => void;
  background?: string;
  maxWidth?: string | number;
};

export const ModalBodil = (props: ModalBaseProps) => {
  const { isMobile } = useDisplayContext();

  return <Modal {...{ ...props, isMobile }} />;
};
